import { createFileRoute } from "@tanstack/react-router";
import { OmOsPage, omosHead } from "@/pages/OmOsPage";

export const Route = createFileRoute("/de/uber-uns")({
  head: () => omosHead("de"),
  component: () => <OmOsPage locale="de" />,
});
